<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
    <div class="salary-field pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }" >
      <div class="mb-4">
        <h5>Salary Calculator</h5>
      </div>
      <div class="salary-calcuation-session pl-0 col-12 mb-3 pr-0 " >
        <div class="col-12 pl-0 pr-0 salary-input-field">
          <input type="number" inputmode="none" name="basic_salary" id="basic_salary" placeholder="Enter Monthly Salary"
            class="form-control no-spin-arrows pl-4" [(ngModel)]="basicSalary" required />
            @if (basicSalaryTouched && basicSalaryInvalid) {
              <div class="warning">
                Basic Salary is required.
              </div>
            }
            <div class="button col-12 p-0">
              <div class="btn btn-primary " (click)="handleClick()">
                Calculate
              </div>
            </div>
          </div>
        </div>

      </div>


      <!-- 2nd section -->
      @if (showSalaryResult) {
        <div class="salary-field pt-2 pl-4 pr-4 pb-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="salary-output">
            <h5>Salary Information</h5>
            <!-- Yearly  -->
            <div class="salary-info-main mt-4">
              <div class="salary-info-heading col-md-4 bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
                <p>Yearly Salary</p>
              </div>
              <div class="salary-info-detail col-md-8">
                <p>{{ yearly +" /- PKR" }}</p>
              </div>
            </div>
            <!-- Montly  -->
            <div class="salary-info-main mt-3">
              <div class="salary-info-heading col-md-4  bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
                <p>Montly Salary</p>
              </div>
              <div class="salary-info-detail col-md-8">
                <p> {{ totalsalary +" /- PKR"}}</p>
              </div>
            </div>
            <!-- daily -->
            <div class="salary-info-main mt-3">
              <div class="salary-info-heading col-md-4  bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
                <p>Daily Salary</p>
              </div>
              <div class="salary-info-detail col-md-8">
                <p> {{ daily +" /- PKR"}}</p>
              </div>
            </div>
            <!-- Hourly -->
            <div class="salary-info-main mt-3">
              <div class="salary-info-heading col-md-4  bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
                <p>Hourly Salary</p>
              </div>
              <div class="salary-info-detail col-md-8">
                <p> {{ hourly +" /- PKR"}}</p>
              </div>
            </div>
            <!-- Over Time -->
            <div class="salary-info-main mt-3">
              <div class="salary-info-heading col-md-4  bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
                <p>OverTime</p>
              </div>
              <div class="salary-info-detail col-md-8" >
                <p> {{ overtime +" /- PKR"}}</p>
              </div>
            </div>
            <!-- Late Check In -->
            <div class="salary-info-main mt-3">
              <div class="salary-info-heading col-md-4  bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
                <p>Late Check In</p>
              </div>
              <div class="salary-info-detail col-md-8 text-center">
                <p> {{ late +" /- PKR"}}</p>
              </div>
            </div>
            <!-- Un Paid Leaves -->
            <div class="salary-info-main mt-3">
              <div class="salary-info-heading col-md-4 bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
                <p>UnPaid Leaves</p>
              </div>
              <div class="salary-info-detail col-md-8">
                <p> {{ unpaid1 +" /- PKR"}}</p>
              </div>
            </div>
            <!-- Absent -->
            <div class="salary-info-main mt-3">
              <div class="salary-info-heading col-md-4 bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
                <p>Absent</p>
              </div>
              <div class="salary-info-detail col-md-8">
                <p> {{ absent +" /- PKR"}}</p>
              </div>
            </div>
            <!-- Montly Tax -->
            <div class="salary-info-main mt-3">
              <div class="salary-info-heading col-md-4 bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
                <p>Montly Tax</p>
              </div>
              <div class="salary-info-detail col-md-8">
                <p> {{ tax +" /- PKR"}}</p>
              </div>
            </div>
          </div>
        </div>
      }



      <!-- 3rd section -->
      @if (showSalaryResult) {
        <div class="salary-field pt-2 pl-4 pr-4 pb-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <h5>Custom Calculation</h5>
          <!-- first custom box -->
          <div class="custom-cal-main mt-4">
            <div class="custom-cal-input-field col-6 pl-3 p-1 pt-0 border rounded">
              <label>Enter Days :</label><br>
              <input type="number" inputmode="none" class="no-spin-arrows" [(ngModel)]="days" required>
            </div>
            <div class="custom-cal-output col-6 ">
              <p>{{(days * daily).toFixed(2) + " /- PKR"}} </p>
            </div>
          </div>
          <!-- 2nd custom box -->
          <div class="custom-cal-main mt-3">
            <div class="custom-cal-input-field col-6 pl-3 p-1 pt-0 border rounded">
              <label>Enter Hours :</label><br>
              <input type="number" inputmode="none" class="no-spin-arrows" [(ngModel)]="showhourly" required>
            </div>
            <div class="custom-cal-output col-6 ">
              <p>{{(showhourly * hourly).toFixed(2) + " /- PKR"}} </p>
            </div>
          </div>
          <!-- 3rd custom box -->
          <div class="custom-cal-main mt-3">
            <div class="custom-cal-input-field col-6 pl-3 p-1 pt-0 border rounded">
              <label>Enter OverTime Hours :</label><br>
              <input type="number" inputmode="none" class="no-spin-arrows" [(ngModel)]="showovertime" required>
            </div>
            <div class="custom-cal-output col-6 ">
              <p>{{(showovertime * overtime).toFixed(2) + " /- PKR"}} </p>
            </div>
          </div>
          <!-- 4th custom box -->
          <div class="custom-cal-main mt-3">
            <div class="custom-cal-input-field col-6 pl-3 p-1 pt-0 border rounded">
              <label>Enter Late CheckIn Hours :</label><br>
              <input type="number" inputmode="none" class="no-spin-arrows" [(ngModel)]="showlatecheckin" required>
            </div>
            <div class="custom-cal-output col-6 ">
              <p>{{(showlatecheckin * late).toFixed(2) + " /- PKR"}} </p>
            </div>
          </div>
          <!-- 5th custom box -->
          <div class="custom-cal-main mt-3">
            <div class="custom-cal-input-field col-6 pl-3 p-1 pt-0 border rounded">
              <label>Enter Unpaid Leaves :</label><br>
              <input type="number" inputmode="none" class="no-spin-arrows" [(ngModel)]="showlunpaid" required>
            </div>
            <div class="custom-cal-output col-6 ">
              <p>{{(showlunpaid * unpaid1).toFixed(2) + " /- PKR"}} </p>
            </div>
          </div>
          <!-- 6th custom box -->
          <div class="custom-cal-main mt-3">
            <div class="custom-cal-input-field col-6 pl-3 p-1 pt-0 border rounded">
              <label>Enter Absent Days:</label><br>
              <input type="number" inputmode="none" class="no-spin-arrows" [(ngModel)]="showlabsent" required>
            </div>
            <div class="custom-cal-output col-6 ">
              <p>{{(showlabsent * absent).toFixed(2) + " /- PKR"}} </p>
            </div>
          </div>
        </div>
      }

    </div>

  </main>
